import React from 'react';
import {Card} from 'react-bootstrap';

const ExecCard = ({ category, title, date, dl_link, img_link }) => {
  return (
    <Card className="mb-3" style={{ border: '1px solid #ccc', padding: '15px' }}>
      <Card.Body style={{ textAlign: 'left' }}>


        {/* Image section */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <img 
            src="/path/to/your/image" 
            alt={title} 
            style={{ maxWidth: '80px', marginRight: '15px' }}
          />
          <div>
            
            {/* Title and description */}
            <h5 style={{ margin: 0 }}>{category}</h5>
            <h4 style={{ fontWeight: 'bold', color: '#1e73be' }}>{title}</h4>
            <p style={{ color: '#6c757d' }}>{date}</p>
          </div>
        </div>

        {/* Download link */}
        <div>
          <a 
            href={dl_link} 
            className="btn btn-link" 
            style={{ color: '#1e73be', textDecoration: 'underline' }}
          >
            Download here
          </a>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ExecCard;